export default "__VITE_ASSET__DTmONPdM__"